import { initDialog } from '../../components/dialog'

export const footer = () => {
  initDialog({
    dialog: document.getElementById('site-newsletter'),
    openSelector: '[data-newsletter-open]',
    closeSelector: '[data-newsletter-close]',
    focusSelector: '.site-newsletter__form input:not([type="hidden"])',
  })
}
